var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrevIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9282 17.7617V2.09575C23.9282 1.13341 22.7958 0.620913 22.0718 1.25315L13.1198 9.08611C12.9997 9.19114 12.9033 9.32067 12.8373 9.466C12.7713 9.61133 12.7372 9.7691 12.7372 9.92871C12.7372 10.0883 12.7713 10.2461 12.8373 10.3914C12.9033 10.5368 12.9997 10.6663 13.1198 10.7713L22.0718 18.6043C22.7958 19.2365 23.9282 18.7229 23.9282 17.7617ZM11.6193 17.7617V2.09575C11.6193 1.13341 10.4868 0.620913 9.76286 1.25315L0.810896 9.08611C0.690704 9.19114 0.594376 9.32067 0.528372 9.466C0.46237 9.61133 0.428221 9.7691 0.428221 9.92871C0.428221 10.0883 0.46237 10.2461 0.528372 10.3914C0.594376 10.5368 0.690704 10.6663 0.810896 10.7713L9.76286 18.6043C10.4868 19.2365 11.6193 18.7229 11.6193 17.7617Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevIcon);
export default __webpack_public_path__ + "static/media/prev_icon.91cb7c98382df2abdf7555f16f55ddfe.svg";
export { ForwardRef as ReactComponent };